<template>
    <div
        :class="summaryBackgroundColor"
    >
        <div
            v-for="(sub_property, sub_index) in property.values"
            :key="'sub-property-label-' + sub_index"
            class="d-flex justify-space-between"
        >
            <template
                v-if="sub_index === 0"
            >
                <h4
                    :class="labelClass"
                >
                    <slot
                        name="label"
                        v-if="!noLabel"
                    >
                        <template
                            v-if="property.label !== ''"
                        >
                            {{ property.label }}
                        </template>
                        <template
                            v-else
                        >
                            {{ getSubPropertyLabel(sub_property) }}
                        </template>
                    </slot>
                </h4>
            </template>
            <template
                v-else
            >
                <h4
                    :class="subLabelClass"
                >
                    <template
                        v-if="showSecondaryLabels"
                    >
                        {{ getSubPropertyLabel(sub_property) }}
                    </template>
                </h4>
            </template>

            <div
                class="d-flex justify-end align-center"
                style="width: 150px;"
            >
                <p
                    class="mr-1 mb-0"
                    :class="textClass(sub_index, sub_property)"
                >
                    {{ getSubPropertyValue(sub_property) }}
                </p>

                <v-tooltip
                    bottom
                    v-if="getSubPropertyDescription(sub_property)"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            v-bind="attrs"
                            v-on="on"
                            :color="infoIconColor"
                            small
                        >
                            $mdiInformation
                        </v-icon>
                    </template>
                    <span v-html="getSubPropertyDescription(sub_property)"/>
                </v-tooltip>
            </div>
        </div>


        <!--        <div>-->
        <!--                    <h4-->
        <!--                        :class="labelClass"-->
        <!--                    >-->
        <!--                        <slot-->
        <!--                            name="label"-->
        <!--                            v-if="!noLabel"-->
        <!--                        >-->
        <!--                            <template-->
        <!--                                v-if="property.label !== ''"-->
        <!--                            >-->
        <!--                                {{ property.label }}-->
        <!--                            </template>-->
        <!--                            <template-->
        <!--                                v-else-->
        <!--                            >-->
        <!--                                {{ getSubPropertyLabel(property.values[0]) }}-->
        <!--                            </template>-->
        <!--                        </slot>-->
        <!--                    </h4>-->

        <!--            <template-->
        <!--                v-if="showSecondaryLabels"-->
        <!--            >-->
        <!--                <h4-->
<!--                            v-for="(sub_property, sub_index) in property.values"-->
<!--                            :key="'sub-property-label-' + sub_index"-->
<!--                            :class="subLabelClass"-->
<!--                            v-if="sub_index !== 0"-->
        <!--                >-->
        <!--                    {{ getSubPropertyLabel(sub_property) }}-->
        <!--                </h4>-->
        <!--            </template>-->
        <!--        </div>-->

        <!--        <div-->
        <!--            style="width: 150px;"-->
        <!--        >-->
        <!--            <div-->
        <!--                v-for="(sub_property, sub_index) in property.values"-->
        <!--                :key="'sub-property-' + sub_index"-->
        <!--                class="d-flex justify-end align-center"-->
        <!--            >-->
        <!--                <p-->
        <!--                    class="mr-1 mb-0"-->
        <!--                    :class="textClass(sub_index, sub_property)"-->
        <!--                >-->
        <!--                    {{ getSubPropertyValue(sub_property) }}-->
        <!--                </p>-->

        <!--                <v-tooltip-->
        <!--                    bottom-->
        <!--                    v-if="getSubPropertyDescription(sub_property)"-->
        <!--                >-->
        <!--                    <template v-slot:activator="{ on, attrs }">-->
        <!--                        <v-icon-->
        <!--                            v-bind="attrs"-->
        <!--                            v-on="on"-->
        <!--                            :color="infoIconColor"-->
        <!--                            small-->
        <!--                        >-->
        <!--                            $mdiInformation-->
        <!--                        </v-icon>-->
        <!--                    </template>-->
        <!--                    <span v-html="getSubPropertyDescription(sub_property)"/>-->
        <!--                </v-tooltip>-->
        <!--            </div>-->
        <!--        </div>-->
    </div>
</template>

<script>
    export default {
        name: "SummaryBreakdown",

        props: {
            'border': {
                type: Boolean,
                default: false,
            },
            'object': {
                type: Object,
                default: () => ({}),
            },
            'property': {
                type: Object,
                default: () => ({
                    'label': '',
                    'values': [],
                }),
            },
            'small': {
                type: Boolean,
                default: false,
            },
            'smallText': {
                type: Boolean,
                default: false,
            },
            'inverted': {
                type: Boolean,
                default: false,
            },
            'greyed': {
                type: Boolean,
                default: false,
            },
            'noLabel': {
                type: Boolean,
                default: false,
            },
            'noDescription': {
                type: Boolean,
                default: false,
            },
            'showSecondaryLabels': {
                type: Boolean,
                default: false,
            },
            'color': {
                type: String,
                default: '',
            },
        },

        computed: {
            labelClass() {
                let css = this.$vuetify.theme.dark ? 'white--text' : 'primary--text';

                if (this.greyed) {
                    css = 'accent--text';
                }

                if (this.inverted) {
                    css = 'white--text';
                }

                if (this.color) {
                    css = this.color + '--text';
                }

                if (this.small) {
                    css += ' summary-value-mobile';
                } else {
                    css += ' summary-value-desktop';
                }

                return css;
            },
            subLabelClass() {
                let css = this.labelClass;

                css += ' font-weight-light';

                return css;
            },
            infoIconColor() {
                let css = 'grey lighten-1';

                if (this.greyed) {
                    css = 'grey';
                }

                if (this.color) {
                    css = this.color;
                }

                return css;
            },
            summaryBackgroundColor() {
                let css = '';

                if (this.inverted) {
                    css = 'accent';
                }

                if (this.greyed && !this.$vuetify.theme.dark) {
                    css = 'grey lighten-3';
                }

                if (this.greyed && this.$vuetify.theme.dark) {
                    css = 'background';
                }

                return css;
            },
            getFirstSubPropertyValue() {
                let key;

                for (let k in this.property.values) {
                    key = k;
                    break;
                }

                return this.getSubPropertyLabel(key);
            },

            debug() {
                return process.env.NODE_ENV !== 'production';
            }
        },

        methods: {
            getSubPropertyValue(property) {
                let suffix = '';
                let value = 0;

                if (typeof this.object !== 'undefined' && typeof this.object[property] !== 'undefined' && typeof this.object[property].value !== 'undefined') {
                    if (this.unlimited && (property === 'productMaximumIndemnity' || property === 'lppBenefits')) {
                        value = 'Unlimited';
                    } else if (property === 'productIndemnificationCoveragePercentage') {
                        value = this.object[property].value + '% Covered';
                    } else if (property === 'productIndemnificationShortfallPercentage') {
                        value = this.object[property].value + '% Shortfall';
                    } else {
                        value = this.currencyFilter(this.object[property]);
                    }
                }

                if (typeof this.object !== 'undefined' && typeof this.object[property] !== 'undefined' && typeof this.object[property].suffix !== 'undefined' && this.object[property].suffix) {
                    suffix = ' ' + this.object[property].suffix;
                }

                return value + suffix;
            },
            getSubPropertyDescription(property) {
                let description = '';

                if (this.noDescription) {
                    return description;
                }

                if (typeof this.object !== 'undefined' && typeof this.object[property] !== 'undefined' && typeof this.object[property].description !== 'undefined' && this.object[property].description) {
                    if (this.debug) {
                        description += property + ' - ';
                    }

                    description += this.object[property].description;
                }

                return description;
            },
            getSubPropertyLabel(property) {
                let label = '';

                if (typeof this.object !== 'undefined' && typeof this.object[property] !== 'undefined' && typeof this.object[property].label !== 'undefined' && this.object[property].label) {
                    label = this.object[property].label;
                }

                return label;
            },
            textClass(index = 0, property = 'estateValue') {
                let css = this.labelClass;

                if (index === 0 && !this.smallText) {
                    css += ' font-weight-bold';
                }

                if (property == 'productIndemnificationCoveragePercentage' && this.object.productIndemnificationShortfall.value > 0) {
                    css = css.replace("primary--text", "red--text");
                    css = css.replace("white--text", "red--text");
                }

                return css;
            },
        }
    }
</script>
